const hasCredentialErrors = (errors: DeserializeError) =>
  errors?.username?.includes('INVALID_USERNAME_OR_PASSWORD');

export default hasCredentialErrors;
